export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  rating: number;
  views: number;
  chapters: ComicChapter[];
  updateDate: string;
}

export interface Category {
  slug: string;
  name: string;
  icon: string;
}

export const categories: Category[] = [
  { slug: 'hanman', name: '韩漫', icon: 'ri-global-line' },
  { slug: 'riman', name: '日漫', icon: 'ri-sun-line' },
  { slug: 'guoman', name: '国漫', icon: 'ri-flag-line' },
  { slug: 'shaonian', name: '少年漫', icon: 'ri-flashlight-line' },
  { slug: 'shaonv', name: '少女漫', icon: 'ri-heart-line' },
  { slug: 'rexue', name: '热血', icon: 'ri-fire-line' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-line' },
  { slug: 'xuanyi', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'maoxian', name: '冒险', icon: 'ri-compass-line' },
];

export const featuredComics: Comic[] = [
  {
    id: 'comic-1',
    title: '绝世武神',
    author: '净无痕',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20art%20style%2C%20martial%20arts%20fantasy%2C%20young%20male%20warrior%20with%20sword%2C%20dramatic%20lighting%2C%20ancient%20Chinese%20setting%2C%20vibrant%20warm%20colors%2C%20clean%20background%2C%20vertical%20poster%20style&width=400&height=560&seq=comic-cover-1&orientation=portrait',
    description: '少年林枫，身怀绝世武魂，从微末中崛起，踏上了逆天改命的武道之路。在这个强者为尊的世界，他誓要成为那至高无上的绝世武神！',
    category: 'guoman',
    tags: ['玄幻', '热血', '战斗'],
    status: '连载中',
    rating: 9.2,
    views: 1280000,
    chapters: Array.from({ length: 186 }, (_, i) => ({
      id: `ch-1-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
  },
  {
    id: 'comic-2',
    title: '恋爱百分百',
    author: '小雨点',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20cover%20style%2C%20young%20couple%20in%20school%20uniform%2C%20cherry%20blossom%20background%2C%20soft%20pastel%20pink%20tones%2C%20clean%20simple%20composition%2C%20vertical%20poster&width=400&height=560&seq=comic-cover-2&orientation=portrait',
    description: '普通高中女生苏小暖，意外与校草学霸签订了恋爱契约。本应是一场虚假的恋爱，却在朝夕相处中擦出了真实的火花。甜到牙疼的校园恋爱故事！',
    category: 'shaonv',
    tags: ['恋爱', '校园', '甜宠'],
    status: '连载中',
    rating: 9.5,
    views: 2560000,
    chapters: Array.from({ length: 142 }, (_, i) => ({
      id: `ch-2-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-3',
    title: '暗夜追踪者',
    author: '夜羽',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20manhua%20cover%20style%2C%20detective%20in%20trench%20coat%20under%20streetlight%2C%20noir%20atmosphere%2C%20rainy%20night%20scene%2C%20dramatic%20shadows%2C%20warm%20amber%20streetlight%20glow%2C%20vertical%20poster&width=400&height=560&seq=comic-cover-3&orientation=portrait',
    description: '连环杀人案震惊全城，退休刑警李默被卷入了一场跨越十年的谜案。每一个线索都指向一个更加黑暗的真相，他能否在下一个受害者出现之前找到真凶？',
    category: 'xuanyi',
    tags: ['悬疑', '推理', '犯罪'],
    status: '连载中',
    rating: 9.0,
    views: 890000,
    chapters: Array.from({ length: 98 }, (_, i) => ({
      id: `ch-3-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-4',
    title: '星海征途',
    author: '星河',
    cover: 'https://readdy.ai/api/search-image?query=Sci-fi%20manhua%20cover%20art%2C%20spaceship%20captain%20looking%20at%20stars%2C%20futuristic%20space%20battle%2C%20neon%20accent%20colors%20on%20dark%20background%2C%20clean%20composition%2C%20vertical%20poster%20style&width=400&height=560&seq=comic-cover-4&orientation=portrait',
    description: '公元3024年，人类已经遍布银河系。年轻的舰长陆星辰率领星际探索队，在未知星域中发现了一个足以改变人类命运的惊天秘密。',
    category: 'kehuan',
    tags: ['科幻', '星际', '冒险'],
    status: '已完结',
    rating: 9.3,
    views: 1670000,
    chapters: Array.from({ length: 220 }, (_, i) => ({
      id: `ch-4-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 7 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-07-15',
  },
  {
    id: 'comic-5',
    title: '魔王大人请住手',
    author: '猫小萌',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20comedy%20cover%2C%20cute%20demon%20lord%20girl%20with%20horns%2C%20chibi%20art%20style%2C%20bright%20colorful%20vibrant%20background%2C%20fun%20expressive%20characters%2C%20vertical%20poster&width=400&height=560&seq=comic-cover-5&orientation=portrait',
    description: '最强魔王被勇者击败后，竟然转生成了人类世界的一名普通高中生！曾经的威严荡然无存，每天被同学欺负、被老师训话，还要面对各种搞笑的日常危机。',
    category: 'gaoxiao',
    tags: ['搞笑', '异世界', '日常'],
    status: '连载中',
    rating: 9.1,
    views: 1980000,
    chapters: Array.from({ length: 156 }, (_, i) => ({
      id: `ch-5-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
  },
  {
    id: 'comic-6',
    title: '首尔之恋',
    author: 'KIM STUDIO',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20drama%20cover%20style%2C%20elegant%20man%20and%20woman%20in%20Seoul%20cityscape%2C%20romantic%20drama%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20modern%20fashion%2C%20vertical%20poster&width=400&height=560&seq=comic-cover-6&orientation=portrait',
    description: '在首尔这座繁华都市中，两个来自完全不同世界的年轻人偶然相遇。一个是顶级财阀继承人，一个是普通咖啡店店员。命运的齿轮开始转动。',
    category: 'hanman',
    tags: ['韩漫', '都市', '恋爱'],
    status: '连载中',
    rating: 9.4,
    views: 3100000,
    chapters: Array.from({ length: 168 }, (_, i) => ({
      id: `ch-6-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-7',
    title: '忍者之路',
    author: '山下太郎',
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20manga%20ninja%20cover%20art%2C%20young%20ninja%20in%20action%20pose%2C%20dynamic%20movement%2C%20traditional%20Japanese%20village%20background%2C%20warm%20earth%20tones%2C%20vertical%20poster%20style&width=400&height=560&seq=comic-cover-7&orientation=portrait',
    description: '在忍者村长大的少年风间，梦想成为最强的忍者。经历了严酷的训练和无数的战斗，他逐渐揭开了一个隐藏在忍者世界背后的巨大阴谋。',
    category: 'riman',
    tags: ['日漫', '忍者', '战斗'],
    status: '已完结',
    rating: 9.6,
    views: 4500000,
    chapters: Array.from({ length: 350 }, (_, i) => ({
      id: `ch-7-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 7 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-06-20',
  },
  {
    id: 'comic-8',
    title: '妖神记',
    author: '唐家三少',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20xianxia%20manhua%20cover%20art%2C%20cultivator%20with%20flowing%20robes%20and%20spiritual%20energy%2C%20%20mystical%20mountain%20landscape%2C%20ethereal%20atmosphere%2C%20warm%20golden%20and%20coral%20tones%2C%20vertical%20poster&width=400&height=560&seq=comic-cover-8&orientation=portrait',
    description: '在这个妖魔横行的世界里，少年聂离获得了能够逆转时光的时空之书。带着前世的记忆重生于少年时代，他誓要改变一切悲剧的命运！',
    category: 'xuanhuan',
    tags: ['玄幻', '重生', '修真'],
    status: '连载中',
    rating: 9.3,
    views: 2890000,
    chapters: Array.from({ length: 210 }, (_, i) => ({
      id: `ch-8-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
  },
];

export const allComics: Comic[] = [
  ...featuredComics,
  {
    id: 'comic-9',
    title: '都市灵异事件簿',
    author: '幽灵',
    cover: 'https://readdy.ai/api/search-image?query=Supernatural%20mystery%20manhua%20cover%2C%20urban%20night%20scene%20with%20ghostly%20figure%2C%20mysterious%20atmosphere%2C%20warm%20street%20lamp%20glow%20against%20darkness%2C%20vertical%20poster%20style&width=400&height=560&seq=comic-cover-9&orientation=portrait',
    description: '在一座看似平静的现代都市中，隐藏着无数超自然事件。大学生林一凡意外获得了看见灵体的能力，从此被卷入了一个又一个不可思议的事件中。',
    category: 'dushi',
    tags: ['都市', '灵异', '悬疑'],
    status: '连载中',
    rating: 8.9,
    views: 760000,
    chapters: Array.from({ length: 88 }, (_, i) => ({
      id: `ch-9-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-01',
  },
  {
    id: 'comic-10',
    title: '热血篮球',
    author: 'Jump社',
    cover: 'https://readdy.ai/api/search-image?query=Sports%20manga%20basketball%20cover%20art%2C%20dynamic%20player%20dunking%2C%20intense%20game%20action%2C%20warm%20gym%20lighting%2C%20energetic%20composition%2C%20vertical%20poster%20style&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '身高只有170cm的少年陈飞，凭借着惊人的弹跳力和永不放弃的精神，在篮球场上创造了一个又一个奇迹。目标是全国大赛冠军！',
    category: 'shaonian',
    tags: ['运动', '热血', '青春'],
    status: '连载中',
    rating: 9.0,
    views: 1450000,
    chapters: Array.from({ length: 175 }, (_, i) => ({
      id: `ch-10-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-04',
  },
  {
    id: 'comic-11',
    title: '魔法学院优等生',
    author: '白露',
    cover: 'https://readdy.ai/api/search-image?query=Magic%20academy%20manhua%20cover%2C%20young%20witch%20with%20magical%20staff%2C%20fantasy%20castle%20school%20background%2C%20warm%20magical%20glow%2C%20enchanting%20atmosphere%2C%20vertical%20poster&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '在艾瑟兰魔法学院，每一个学生都梦想成为最强大的魔法师。平凡少女莉莉凭借勤奋和智慧，在天才云集的学院中闯出了自己的一片天。',
    category: 'maoxian',
    tags: ['魔法', '校园', '冒险'],
    status: '连载中',
    rating: 8.8,
    views: 920000,
    chapters: Array.from({ length: 130 }, (_, i) => ({
      id: `ch-11-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-02',
  },
  {
    id: 'comic-12',
    title: '极道重生',
    author: '黑岩',
    cover: 'https://readdy.ai/api/search-image?query=Rebirth%20martial%20arts%20manhua%20cover%2C%20determined%20warrior%20with%20scar%2C%20ancient%20Chinese%20city%20background%2C%20dramatic%20warm%20lighting%2C%20intense%20expression%2C%20vertical%20poster&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '一代武学宗师遭人暗算陨落，却意外重生回到了少年时代。带着前世的武学记忆，他要在这个世界重新踏上巅峰，向仇敌复仇！',
    category: 'rexue',
    tags: ['热血', '重生', '战斗'],
    status: '连载中',
    rating: 9.1,
    views: 1850000,
    chapters: Array.from({ length: 200 }, (_, i) => ({
      id: `ch-12-${i + 1}`,
      title: `第${i + 1}话`,
      number: i + 1,
      updateDate: `2026-${String(Math.max(1, 8 - Math.floor(i / 30))).padStart(2, '0')}-${String((i % 28) + 1).padStart(2, '0')}`,
    })),
    updateDate: '2026-08-03',
  },
];

export const faqItems = [
  {
    question: '什么是下拉式连续阅读？',
    answer: '下拉式连续阅读是布丁漫画网独创的阅读模式。无需点击翻页按钮，只需向下滑动鼠标或手指，漫画内容就会自动连续展示。这种模式让阅读体验更加流畅自然，完全沉浸在漫画的世界中，不会因为翻页操作而打断阅读节奏。',
  },
  {
    question: '布丁漫画网的漫画资源是否免费？',
    answer: '布丁漫画网提供大量免费漫画资源供用户阅读。我们与国内外众多漫画作者和平台合作，为用户提供正版、高质量的漫画内容。部分独家内容和最新章节可能采用付费模式，但我们始终保留大量免费内容，让每一位漫画爱好者都能享受阅读的乐趣。',
  },
  {
    question: '支持哪些类型的漫画？',
    answer: '布丁漫画网涵盖了韩漫、日漫、国漫等主流漫画类型，同时按内容分为少年漫、少女漫、热血、玄幻、都市、悬疑、搞笑、科幻、冒险等多种分类。无论你喜欢什么类型的漫画，都能在这里找到心仪的作品。',
  },
  {
    question: '如何进行下拉式阅读？',
    answer: '进入任意漫画的详情页面，点击"开始阅读"按钮，即可进入下拉式连续阅读模式。在阅读界面中，您只需向下滚动页面，所有章节内容将自动连续展示。您也可以使用右侧的章节导航快速跳转到任意章节。',
  },
  {
    question: '漫画更新频率是怎样的？',
    answer: '布丁漫画网上的连载作品通常保持每周更新一到两话的频率。热门作品可能会更频繁地更新。您可以在作品详情页查看具体的更新日程，也可以关注作品以获取更新通知。',
  },
  {
    question: '支持手机端阅读吗？',
    answer: '是的，布丁漫画网采用响应式设计，完美适配手机、平板和电脑等多种设备。在手机上同样支持下拉式连续阅读，只需在浏览器中打开我们的网站，即可随时随地畅享漫画阅读体验。',
  },
];